export default "__VITE_ASSET__93b8cfad__"